import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, {useEffect} from "react";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./Router";
import ReactToastify from "./components/shared/ReactToastify";
import i18n from "./config/i18n";
import { AnalyticsContextProvider } from "./contexts/AnalyticsContext";
import ErrorBoundary from "./pages/ErrorPage";
import NavigationProviders from "./providers/NavigationProviders";
import queryClient from "./react-query/QueryClient";
import { store } from "./redux/Store";
import "./config/firebaseConfig";
import {loadKlaviyo} from "./utils/klaviyoHelper";

function App() {
  useEffect(() => {
    loadKlaviyo()
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store} data-testid="provider">
        <I18nextProvider i18n={i18n} data-testid="i18next-provider">
          <ErrorBoundary>
            <Router>
              <NavigationProviders>
                <ReactToastify>
                  <AnalyticsContextProvider>
                    <AppRoutes />
                    <ReactQueryDevtools initialIsOpen={false} />
                  </AnalyticsContextProvider>
                </ReactToastify>
              </NavigationProviders>
            </Router>
          </ErrorBoundary>
        </I18nextProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
